export const BULK_USER_DATA_ACTIONS = {
  CREATE: 'create',
  MODIFY: 'modify',
  DELETE: 'delete',
};
